import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "~/lib/utils";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { Tooltip } from "~/components/Tooltip";
import { faCheckCircle, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { AssetTableRowData } from "../types";

// // // //

function DepositInsurance(props: {
    item: AssetTableRowData;
    inline?: boolean;
}) {
    const { item, inline = false } = props;

    // Displays when no value is present
    const empty = (
        <div
            className={cn("flex", {
                "justify-center": !inline,
                "justify-end": inline,
            })}
        >
            <Emdash />
        </div>
    );

    if (item.isAsset) {
        const isEmpty = item.has_deposit_insurance === null;

        // Return Emdash if no data is present
        if (isEmpty) {
            return empty;
        }

        // Define isRedeemable flag
        const isInsured = item.has_deposit_insurance === true;
        const descriptionFallback = isInsured ? "Yes" : "No";
        const description =
            item.deposit_insurance_description || descriptionFallback;

        const icon = (
            <FontAwesomeIcon
                icon={isInsured ? faCheckCircle : faTimesCircle}
                className={cn("h-4", {
                    "text-blue-400": isInsured,
                    "text-muted-foreground": !isInsured,
                })}
            />
        );

        return (
            <Tooltip
                placement="top"
                tooltipContent={
                    <div className="w-max px-3">
                        <p className="py-1.5 text-sm max-w-120">
                            {description}
                        </p>
                    </div>
                }
            >
                {({ setTriggerRef }) => (
                    <div
                        className={cn("w-full flex cursor-default", {
                            "justify-center": !inline,
                            "items-center gap-1 justify-end": inline,
                        })}
                        ref={setTriggerRef}
                    >
                        {icon}
                        {inline && <>{isInsured ? "Yes" : "No"}</>}
                    </div>
                )}
            </Tooltip>
        );
    }

    return empty;
}

// // // //

export const DEPOSIT_INSURANCE: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: "deposit_insurance",
    label: (
        <>
            Deposit
            <br />
            Insurance
        </>
    ),
    type: ColumnTypes.string,
    width: 120,
    loginRequired: true,
    render: (item) => {
        return <DepositInsurance item={item} />;
    },
};

// // // //

export const DEPOSIT_INSURANCE_INLINE: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    ...DEPOSIT_INSURANCE,
    render: (item) => {
        return <DepositInsurance item={item} inline />;
    },
};
